// export const API_HOST = "http://localhost:3001/api/v1/";

// export const API_HOST = "https://devhygiene.toothlens.com/api/v1/";



// export const API_HOST = "https://sim-dev.toothlens.com/api/v1/";

export const API_HOST = "https://sim.toothlens.com/api/v1/";
